import { Card, Typography } from '@mui/material';

import { Flex } from 'src/components/Flex';
import { DEFAULT_BORDER } from 'src/constants';
import { addDaysToDate, formatDate } from 'src/utils/utils';

interface SelfBillingInvoiceDetailsProps {
    invoiceDate: Date;
    invoiceStatus: string;
    invoiceNumber: number;
    partnerReference: string;
}

export const SelfBillingInvoiceDetails: React.FC<SelfBillingInvoiceDetailsProps> = ({
    invoiceDate,
    invoiceStatus,
    invoiceNumber,
    partnerReference,
}) => {
    const formattedInvoiceDate = formatDate({ date: new Date(invoiceDate) });

    const dueDate = addDaysToDate({ date: invoiceDate, days: 7 });
    const formattedInvoiceDueDate = formatDate({ date: new Date(dueDate) });

    return (
        <>
            <Flex flexDirection="row" gap="24px">
                <Card
                    gap="36px"
                    sx={{
                        ...DEFAULT_BORDER,
                        backgroundColor: '#FFFFFF',
                        boxShadow: '0px 4px 20px rgba(38, 50, 56, 0.1)',
                        padding: '32px 24px',
                        flex: 1,
                    }}
                >
                    <Flex flexDirection="row" gap="19px">
                        <Flex flex={2}>
                            <Typography
                                fontSize="14px"
                                fontWeight="500"
                                lineHeight="20px"
                                color="#1d1d1b"
                            >
                                <strong>Customer name: </strong> New Payment Innovation Limited
                            </Typography>
                        </Flex>
                    </Flex>
                </Card>

                <Card
                    gap="36px"
                    sx={{
                        ...DEFAULT_BORDER,
                        backgroundColor: '#FFFFFF',
                        boxShadow: '0px 4px 20px rgba(38, 50, 56, 0.1)',
                        padding: '32px 24px',
                        flex: 1,
                    }}
                >
                    <Flex flexDirection="row" gap="19px">
                        <Flex flex={2}>
                            <Typography
                                fontSize="14px"
                                fontWeight="500"
                                lineHeight="20px"
                                color="#1d1d1b"
                            >
                                <strong>Reference: </strong> {partnerReference}
                            </Typography>
                        </Flex>
                    </Flex>
                </Card>
            </Flex>
            <Flex flexDirection="row" gap="24px" marginTop="24px">
                <Card
                    gap="36px"
                    sx={{
                        ...DEFAULT_BORDER,
                        backgroundColor: '#FFFFFF',
                        boxShadow: '0px 4px 20px rgba(38, 50, 56, 0.1)',
                        padding: '32px 24px',
                        flex: 1,
                    }}
                >
                    <Flex flexDirection="row" gap="19px">
                        <Flex flex={2}>
                            <Typography
                                fontSize="14px"
                                fontWeight="500"
                                lineHeight="20px"
                                color="#1d1d1b"
                            >
                                <strong>Invoice Status: </strong> {invoiceStatus}
                            </Typography>
                        </Flex>
                    </Flex>
                </Card>
                <Card
                    gap="36px"
                    sx={{
                        ...DEFAULT_BORDER,
                        backgroundColor: '#FFFFFF',
                        boxShadow: '0px 4px 20px rgba(38, 50, 56, 0.1)',
                        padding: '32px 24px',
                        flex: 1,
                    }}
                >
                    <Flex flexDirection="row" gap="19px">
                        <Flex flex={2}>
                            <Typography
                                fontSize="14px"
                                fontWeight="500"
                                lineHeight="20px"
                                color="#1d1d1b"
                            >
                                <strong>Invoice Number: </strong> {invoiceNumber}
                            </Typography>
                        </Flex>
                    </Flex>
                </Card>
                <Card
                    gap="36px"
                    sx={{
                        ...DEFAULT_BORDER,
                        backgroundColor: '#FFFFFF',
                        boxShadow: '0px 4px 20px rgba(38, 50, 56, 0.1)',
                        padding: '32px 24px',
                        flex: 1,
                    }}
                >
                    <Flex flexDirection="row" gap="19px">
                        <Flex flex={2}>
                            <Typography
                                fontSize="14px"
                                fontWeight="500"
                                lineHeight="20px"
                                color="#1d1d1b"
                            >
                                <strong>Invoice Date:</strong> {formattedInvoiceDate}
                            </Typography>
                        </Flex>
                    </Flex>
                </Card>
                <Card
                    gap="36px"
                    sx={{
                        ...DEFAULT_BORDER,
                        backgroundColor: '#FFFFFF',
                        boxShadow: '0px 4px 20px rgba(38, 50, 56, 0.1)',
                        padding: '32px 24px',
                        flex: 1,
                    }}
                >
                    <Flex flexDirection="row" gap="19px">
                        <Flex flex={2}>
                            <Typography
                                fontSize="14px"
                                fontWeight="500"
                                lineHeight="20px"
                                color="#1d1d1b"
                            >
                                <strong>Due Date:</strong> {formattedInvoiceDueDate}
                            </Typography>
                        </Flex>
                    </Flex>
                </Card>
            </Flex>
        </>
    );
};
